<template>
	<div class="replaceLink">
		<el-dialog :title="title" width="400px" :visible.sync="dialogLinkVisible" @close="resetForms('linkFrom')">
			<div class="product_box">
				<product-box :row="row" :tabName="tabName"></product-box>
			</div>
			<div class="user_info_box mt-10">
				<user-info-box :row="row"></user-info-box>
			</div>
			<div class="mt-20">
				<el-form :model="linkFrom" ref="linkFrom" :rules="linkRuels">
					<el-form-item label="商品链接：" :label-width="formLabelWidth" prop="partner_url" v-if="!$isKs(platformId)">
						<el-input v-model="linkFrom['partner_url']" type="textarea" autocomplete="off" placeholder="请填写达人上橱窗的带货链接"></el-input>
					</el-form-item>
					<el-form-item label="商品ID：" :label-width="formLabelWidth" prop="third_product_id" v-if="$isKs(platformId)">
						<el-input v-model="linkFrom['third_product_id']" type="textarea" autocomplete="off" placeholder="请填写达人上橱窗的带货商品ID"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogLinkVisible = false">取 消</el-button>
				<el-button type="primary" @click="linkConfirm">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="提示" width="25%" :visible.sync="visibleWarning">
			<div>
				<i class="el-icon-warning warning"></i>
				{{ error_desc }}
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="visibleWarning = false">重新更换{{ btnText }}</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import productBox from '@/components/common/productBox';
import userInfoBox from '@/components/common/userInfoBox';
import { editUrl, editProductId } from '@/api/cooperationProgress';
import { PLATFORM_KS, PLATFORM_DY, PLATFORM_SP } from '@/utils/dataMap';
export default {
	components: {
		productBox,
		userInfoBox,
	},
	name: 'replaceLink',
	data() {
		return {
			dialogLinkVisible: false,
			visibleWarning: false,
			linkFrom: {
				cooperate_id: '',
				partner_url: '',
				third_product_id: '',
			},
			linkRuels: {
				partner_url: [{ required: true, message: '请填写达人上橱窗的带货链接', trigger: 'blur' }],
				third_product_id: [{ required: true, message: '请填写达人上橱窗的带货商品ID', trigger: 'blur' }],
			},
			formLabelWidth: '100px',
			row: {},
			tabName: '',
			title: '',
			error_desc: '',
		};
	},
	computed: {
		platformId() {
			return +this.row?.platform_id;
		},
		api() {
			const _objs = {
				[+PLATFORM_DY.value]: editUrl,
				[+PLATFORM_KS.value]: editProductId,
				[+PLATFORM_SP.value]: editUrl,
			};
			return _objs[this.platformId];
		},
		btnText() {
			const temPF = {
				[dataMap.PLATFORM_DY.value]: '链接',
				[dataMap.PLATFORM_KS.value]: 'ID',
				[dataMap.PLATFORM_SP.value]: '链接',
			};
			return temPF[this.platformId] || '';
		},
	},
	methods: {
		initLinkFun(row, tabName, title) {
			this.title = title;
			this.tabName = tabName;
			this.row = row;
			this.dialogLinkVisible = true;
		},
		linkConfirm() {
			this.linkFrom.cooperate_id = this.row.cooperate_id;
			this.$refs.linkFrom.validate(async valid => {
				if (valid) {
					const { cooperate_id, partner_url, third_product_id } = this.linkFrom;
					const temPF = {
						[dataMap.PLATFORM_DY.value]: { cooperate_id, partner_url },
						[dataMap.PLATFORM_KS.value]: { cooperate_id, third_product_id },
						[dataMap.PLATFORM_SP.value]: { cooperate_id, partner_url },
					};
					const { code, data } = await this.api(temPF[this.platformId]||{});
					if (code == 0) {
						if (data.code === 0) {
							this.$message.success('操作成功');
							this.dialogLinkVisible = false;
							this.$emit('refreshList');
						} else {
							this.error_desc = data.message;
							this.visibleWarning = true;
						}
					}
				}
			});
		},
		//重置弹框表单
		resetForms(from) {
			this.$refs[from].resetFields();
		},
	},
};
</script>
<style lang="less" scoped>
.warning {
	color: #fa8f14;
}
</style>
